import React, { useState } from "react";
import {Icon} from '../Components/UI/Icon'
import PricingCard from '../Components/PricingCard'
import AddNewFornitore from '../Pages/AddNewFornitore'


export default function TestPage({ children }) {



  return (
    <AddNewFornitore/>
  );
};

